var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNetworkingExp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26 -226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6649 19.2168C20.8242 18.7482 19.2384 17.6345 17.2951 15.3812L17.2305 15.3046 17.2915 15.2342C19.169 13.0681 20.812 11.625 22.7243 11.625 23.9055 11.6235 25.0189 12.1767 25.731 13.1191L23.8393 14.2112 28.6488 15.5 29.9376 10.6885 27.9756 11.8213C26.7942 10.0815 24.8273 9.04037 22.7243 9.04167 19.601 9.04167 17.3171 11.2604 15.3385 13.5418 13.3587 11.2582 11.076 9.04167 7.95279 9.04167 4.48073 9.01677 1.64592 11.8113 1.62103 15.2833 1.59615 18.7554 4.39063 21.5902 7.86267 21.6151 7.89273 21.6153 7.92276 21.6153 7.95279 21.6151 11.0657 21.6151 13.2732 19.458 15.3385 17.0678 17.3868 19.4431 19.6111 21.3626 22.7243 21.6151 26.2205 21.8979 28.6931 19.1412 28.716 17.0445 28.716 17.042 28.7139 17.04 28.7114 17.0401 28.7096 17.0401 28.708 17.0412 28.7073 17.0429 28.211 18.5516 25.193 19.8594 22.6649 19.2168ZM13.3839 15.3786C11.3844 17.6923 9.85477 19.0317 7.95279 19.0317 5.90747 19.0648 4.22262 17.4336 4.18952 15.3883 4.15645 13.3429 5.78767 11.6581 7.83299 11.625 7.87293 11.6244 7.91285 11.6244 7.95279 11.625 9.86607 11.625 11.5087 13.0678 13.3865 15.2342L13.4479 15.3046Z",
    fill: "#FFFFFF",
    transform: "matrix(1.03226 0 0 1 26 226)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetworkingExp);
export default __webpack_public_path__ + "static/media/icon-networking-exp.abc65b6cd7d30f88016462022b2178b7.svg";
export { ForwardRef as ReactComponent };